import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '../views/Login.vue'
import { useAuth } from '@/composables/useAuth'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/index.html',
        component: Login,
        alias: '/',
    },
    {
        path: '/',
        name: 'login',
        component: Login,
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "common" */ '../views/ResetPasswordStep1.vue'),
    },
    {
        path: '/reset-password-token/:token',
        name: 'reset-password-token',
        component: () => import(/* webpackChunkName: "common" */ '../views/ResetPasswordStep2.vue'),
    },
    {
        path: '/add-documents',
        name: 'add-documents',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "common" */ '../views/AddDocuments.vue'),
    },
    {
        path: '/advices',
        name: 'advices',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "advices" */ '../views/Advices.vue'),
    },
    {
        path: '/advice/:adviceId',
        name: 'advice',
        meta: {
            requiresAuth: true,
        },
        props: true,
        component: () => import(/* webpackChunkName: "advices" */ '../views/Advice.vue'),
    },
    {
        path: '/drivers',
        name: 'drivers',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "drivers" */ '../views/Drivers.vue'),
    },
    {
        path: '/drivers/add',
        name: 'add-driver',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "drivers" */ '../views/AddEditDriver.vue'),
    },

    {
        path: '/drivers/edit',
        name: 'edit-driver',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "drivers" */ '../views/AddEditDriver.vue'),
    },
    {
        path: '/vehicles',
        name: 'vehicles',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "vehicles" */ '../views/Vehicles.vue'),
    },
    {
        path: '/vehicles/add',
        name: 'add-vehicle',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "vehicles" */ '../views/AddEditVehicle.vue'),
    },
    {
        path: '/vehicles/edit/:vehicleId/:vehicleNumber',
        name: 'edit-vehicle',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "vehicles" */ '../views/AddEditVehicle.vue'),
    },
    {
        path: '/users',
        name: 'users',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
    },
    {
        path: '/users/add',
        name: 'add-user',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "users" */ '../views/AddEditUser.vue'),
    },

    {
        path: '/users/edit',
        name: 'edit-user',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "users" */ '../views/AddEditUser.vue'),
    },
    {
        path: '/invoices',
        name: 'invoices',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "invoices" */ '../views/Invoices.vue'),
    },
    {
        path: '/invoices/add',
        name: 'add-invoice',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "invoices" */ '../views/AddEditInvoice.vue'),
    },
    {
        path: '/invoices/edit',
        name: 'edit-invoice',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "invoices" */ '../views/AddEditInvoice.vue'),
    },
    {
        path: '/invoices/correction',
        name: 'correction-invoice',
        meta: {
            requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "invoices" */ '../views/AddEditInvoice.vue'),
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

router.beforeEach(async to => {
    window.scrollTo(0, 0)

    const { isLoggedIn, checkTokenValidity } = useAuth()

    if (!isLoggedIn.value) {
        // read token from storage
        await checkTokenValidity()
        // guard for routes with requireAuth attr
        if (to.meta.requiresAuth && !isLoggedIn.value) {
            router.push({ name: 'login' })
            return false
        }
    }

    // go to dashboard if logged in
    if (to.name === 'login' && isLoggedIn.value) {
        router.push({ name: 'advices' })
    }
})

export default router
